function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Add Game chooser — three destination cards, no nested Arcade overlays.
 *
 * Free → Saito Wiki Applications
 * Sale / Rent → Saito Store
 */
var AddGameOverlayTemplate = require('./add-game.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var WIKI_APPLICATIONS_URL = 'https://wiki.saito.io/applications';
var AddGameOverlay = /*#__PURE__*/function () {
  function AddGameOverlay(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, AddGameOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
  }

  /**
   * Home options. Append a fourth entry later without redesigning the grid.
   * Upload ROM belongs on an NWASM-provided game card, not here.
   */
  return _createClass(AddGameOverlay, [{
    key: "returnHomeOptions",
    value: function returnHomeOptions() {
      return [{
        id: 'free',
        title: 'Free Games',
        description: 'Browse and install free peer-to-peer games.',
        image: '/arcade/img/free_games.png',
        view: 'free'
      }, {
        id: 'sale',
        title: 'Games for Sale',
        description: 'Purchase games from creators on Saito.',
        image: '/arcade/img/add_game.png',
        view: 'sale'
      }, {
        id: 'rent',
        title: 'Games for Rent',
        description: 'Play premium titles with flexible access.',
        image: '/arcade/img/rent_game.png',
        view: 'rent'
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var options = this.returnHomeOptions();
      this.overlay.show(AddGameOverlayTemplate({
        view: 'home',
        options: options,
        count: options.length
      }));
      this.attachEvents(options);
    }
  }, {
    key: "close",
    value: function close() {
      this.overlay.hide();
    }
  }, {
    key: "openStore",
    value: function openStore() {
      if (this.app.modules.returnModule('Store')) {
        this.close();
        navigateWindow('/store', 200);
        return;
      }
      siteMessage('The Saito Store is not available on this node.', 3000);
    }
  }, {
    key: "openWikiApplications",
    value: function openWikiApplications() {
      this.close();
      window.location.assign(WIKI_APPLICATIONS_URL);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var root = document.querySelector('.arcade-add-game');
      if (!root) {
        return;
      }
      root.querySelectorAll('.choice').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          var id = btn.getAttribute('data-action');
          var option = options.find(function (o) {
            return o.id === id;
          }) || {
            id: id
          };
          _this.selectHomeOption(option);
        };
      });
    }
  }, {
    key: "selectHomeOption",
    value: function selectHomeOption() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.app.connection.emit('arcade-add-game-select', option);
      if (option.view === 'free' || option.id === 'free') {
        this.openWikiApplications();
        return;
      }
      if (option.view === 'sale' || option.id === 'sale' || option.view === 'rent' || option.id === 'rent') {
        this.openStore();
      }
    }
  }]);
}();
module.exports = AddGameOverlay;